export default "__VITE_ASSET__C45qkB27__"